/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    $RichText,
    RichTextStyleParams,
    RichTextProps,
    ExtendRichTextProps,
    getProp,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, Signal} from '@gongxigames/framework/core/fragments/store/Store';
import type {Override} from '@gongxigames/framework/lib/types/basic';
import {UITextStyles} from './styles';
import {RichText as RichTextConstructor} from '@gongxigames/framework/core/fragments/display';

export type UITextPropsToOverride = ExtendRichTextProps<{
    stylePreset: UITextStyles;
}>;

export type UITextProps = Override<UITextPropsToOverride, {
    style?: RichTextStyleParams | Signal<RichTextStyleParams>;
}>;

export const $UIText: FC<UITextProps> = (props) => {
    const styleProp = props.style;

    props.style = Store.computed(() => {
        const stylePreset = getProp(props.stylePreset);
        const style = getProp(styleProp, {});

        return {
            ...RichTextConstructor.getStyle(stylePreset),
            ...style
        };
    });

    return <$RichText {...props as RichTextProps}/>;
};